import { FC, ReactNode } from 'react';

type StatusScreenProps = {
  heading: string;
  description: string;
  /** Omit for a terminal state — the screen then offers nothing onward, deliberately. */
  action?: ReactNode;
  footNote?: ReactNode;
  testId: string;
  headingTestId: string;
  descriptionTestId?: string;
};

/**
 * Every full-page outcome the portal shows — errored, ended, unavailable — is the same shape:
 * heading, explanation, and at most one way forward. One component so they cannot drift apart
 * visually, with the action passed in because what "forward" means differs per case (a reload,
 * a retry callback, or nothing at all).
 */
export const StatusScreen: FC<StatusScreenProps> = ({ heading, description, action, footNote, testId, headingTestId, descriptionTestId }) => (
  <main className='bg-bg-default flex min-h-dvh flex-col items-center justify-center gap-6 px-6 text-center' data-testid={testId}>
    <h1 className='text-text-primary text-2xl font-semibold' data-testid={headingTestId}>
      {heading}
    </h1>
    <p className='text-text-secondary max-w-md' data-testid={descriptionTestId}>
      {description}
    </p>
    {action}
    {footNote}
  </main>
);
